var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_2960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.24067 -0.196533L5.16424 0.0631303V7.59622L5.24067 7.67241L8.73734 5.60555L5.24067 -0.196533Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2406 -0.196533L1.74322 5.60555L5.2406 7.67241L5.24013 4.01623L5.2406 -0.196533Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.23972 8.33435L5.19675 8.38657V11.0701L5.23972 11.1959L8.73853 6.26843L5.23972 8.33435Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.23964 11.1954V8.33385L1.7432 6.26746L5.23964 11.1954Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24074 7.67289L8.73742 5.60603L5.24027 4.01648L5.24074 7.67289Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7432 5.60579L5.24059 7.67266L5.24011 4.01648L1.7432 5.60579Z",
    fill: "#919191"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_2960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.5862,
    height: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.6e7f6c9252478b3ae2a1952d0e9ddd02.svg";
export { ForwardRef as ReactComponent };